import { Routes, Route } from 'react-router-dom';
import { PurchaseOrdersListPage } from './purchase-orders-list-page';
import { PurchaseOrderCreatePage } from './purchase-order-create-page';
import { PurchaseOrderDetailPage } from './purchase-order-detail-page';

export function PurchaseOrdersPage() {
  return (
    <Routes>
      <Route index element={<PurchaseOrdersListPage />} />
      <Route path="new" element={<PurchaseOrderCreatePage />} />
      <Route path=":id" element={<PurchaseOrderDetailPage />} />
    </Routes>
  );
}
